/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import GroupsIcon from 'icons/GroupsIcon';

const messages = defineMessages({
  title: {id: 'navigation.groups'},
});

const GroupsItem = () => (
  <RouteLinkItem
    iconBefore={GroupsIcon}
    route="midas/staff/groups"
    title={messages.title}
  />
);

export default GroupsItem;
